if ( typeof ProductImageZoom !== 'function' ) {

	// Which control opened the lightbox - focus returns here on close.
	let pbZoomReturnFocus = null;

	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			this.zoom = document.getElementById('zoom');

			if ( ! this.zoom ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.setAttribute('role', 'dialog');
				this.zoom.setAttribute('aria-modal', 'true');
				this.zoom.setAttribute('aria-label', this.getAttribute('data-dialog-label') || 'Zoomed image');
				this.zoom.setAttribute('tabindex', '-1');
				this.zoom.innerHTML = `
					<img alt="">
					<button type="button" class="zoom__exit" aria-label="${this.getAttribute('data-close-label') || 'Close'}">${KROWN.settings.symbols.zoom_out}</button>
					<span class="zoom__loader" aria-hidden="true">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);

				this.zoom.querySelector('.zoom__exit').addEventListener('click', this.#close.bind(this));
				this.zoom.querySelector('.zoom__overlay').addEventListener('click', this.#close.bind(this));
				this.zoom.querySelector('img').addEventListener('click', this.#close.bind(this));

				this.zoom.addEventListener('keydown', (e) => {
					if ( e.key === 'Escape' ) {
						e.preventDefault();
						this.#close();
					} else if ( e.key === 'Tab' ) {
						// only the close button is interactive - keep focus on it
						e.preventDefault();
						this.zoom.querySelector('.zoom__exit').focus();
					}
				});
			}

			this.addEventListener('click', this.#open.bind(this));
			this.addEventListener('keydown', (e) => {
				if ( e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' ) {
					e.preventDefault();
					this.#open();
				}
			});

		}

		#open() {

			pbZoomReturnFocus = this;

			this.image = this.zoom.querySelector('img');
			this.zoom.classList.add('opened');
			this.image.src = this.getAttribute('data-image');

			const ready = () => {
				this.zoom.classList.add('loaded');
				const exit = this.zoom.querySelector('.zoom__exit');
				if ( exit ) exit.focus();
			};

			if ( this.image.complete && this.image.naturalWidth > 0 ) {
				ready();
			} else {
				this.image.addEventListener('load', ready, { once: true });
				this.image.addEventListener('error', ready, { once: true });
			}

		}

		#close() {

			this.zoom.classList.remove('opened');

			const img = this.zoom.querySelector('img');
			setTimeout(() => {
				this.zoom.classList.remove('loaded');
				if ( img ) img.src = '';
			}, 300);

			if ( pbZoomReturnFocus && typeof pbZoomReturnFocus.focus === 'function' ) {
				pbZoomReturnFocus.focus();
			}
			pbZoomReturnFocus = null;

		}

	}

	if ( typeof customElements.get('product-image-zoom') === 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
